import { AfterViewInit, Component, HostListener, Input, ViewChild } from '@angular/core';
import { InputTextarea } from 'primeng/inputtextarea';
import { BaseFormComponent } from '../../../base-components';
import { debounceTime, delay, startWith, takeUntil } from 'rxjs/operators';
import { removeCharacters } from '@foxeet/utils/*';

@Component({
  selector: 'ui-form-input-textarea',
  templateUrl: './form-input-textarea.component.html',
  styleUrls: ['./form-input-textarea.component.scss'],
})
export class FormInputTextAreaComponent extends BaseFormComponent<string> implements AfterViewInit {
  @Input() autoResize = false;
  @Input() rows = 3;
  @Input() tooltip?: string;

  /**
   * @todo: Revisar!! Esto es porque no se redimensiona correctamente
   */
  @ViewChild(InputTextarea) textarea!: InputTextarea;

  ngAfterViewInit(): void {
    if (this.autoResize) {
      this.control.valueChanges.pipe(startWith(this.control.value), debounceTime(1000), delay(1000), takeUntil(this._componentDestroyed)).subscribe((v) => this.textarea?.resize());
    }
  }

  /** **** */


  /**
   * Detecta cuando se pega texto (CTRL+V) en el textarea
   * @param event Evento de pegado
   */
  @HostListener('paste', ['$event'])
  onPaste(event: ClipboardEvent): void {
    // Prevenir el comportamiento predeterminado del navegador
    event.preventDefault();

    const input = event.target as HTMLInputElement;

    const clipboardData = event.clipboardData;
    const pastedText = clipboardData?.getData('text') ?? '';
    const cleanedText = removeCharacters(pastedText);

    const start = input.selectionStart ?? undefined;
    const end = input.selectionEnd ?? undefined;

    const originalValue = input.value;
    const newValue = originalValue.slice(0, start) + cleanedText + originalValue.slice(end);

    input.value = newValue;
    this.control.setValue(newValue);

    const newPos = start + cleanedText.length;
    input.setSelectionRange(newPos, newPos);
  }

  /** **** */
}
